export const SUCCESS_RESPONSE_LIST = [200, 201, "success", "Success"];

export const FAIL_RESPONSE_LIST = [401, "Failed"];

export const Tab1 = [{title : "Client details" ,id: 1}, {title : "V-KYC" ,id: 2}];